import { signalStore, withState, withMethods, patchState } from "@ngrx/signals";
import { UserPermission } from "src/app/core/interfaces/detailed-user-interface";
import { UserScopeInterface } from "src/app/core/interfaces/user-scope-interface";

interface UserState {
  isLoggedIn: boolean;
  divisionId: number | null;
  divisionName: string;
  delegationId: number | null;
  delegationName: string;
  areaId: number | null;
  areaName: string;
  permission: UserPermission;
}

const initialState: UserState = {
  isLoggedIn: false,
  divisionId: null,
  divisionName: "",
  delegationId: null,
  delegationName: "",
  areaId: null,
  areaName: "",
  permission: UserPermission.User,
};

export const UserStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store) => {
    return {
      setLoginStatus(isLoggedIn: boolean): void {
        patchState(store, { isLoggedIn });
      },
      setUserScope(scope: UserScopeInterface): void {
        patchState(store, {
          isLoggedIn: true,
          divisionId: scope.divisionId,
          divisionName: scope.divisionName,
          delegationId: scope.delegationId,
          delegationName: scope.delegationName,
          areaId: scope.areaId,
          areaName: scope.areaName,
          permission: scope.permission,
        });
      },
      setDivisionId(divisionId: number): void {
        patchState(store, { divisionId });
      },
      setDelegationId(delegationId: number): void {
        patchState(store, { delegationId });
      },
      setAreaId(areaId: number): void {
        patchState(store, { areaId });
      },
      setDivisionName(divisionName: string): void {
        patchState(store, { divisionName });
      },
      setDelegationName(delegationName: string): void {
        patchState(store, { delegationName });
      },
      setAreaName(areaName: string): void {
        patchState(store, { areaName });
      },
      isUserLoggedIn(): boolean {
        return store.isLoggedIn();
      },
      getUserDivisionId(): number | null {
        return store.divisionId();
      },
      getUserDelegationId(): number | null {
        return store.delegationId();
      },
      getUserAreaId(): number | null {
        return store.areaId();
      },
      getUserDivisionName(): string {
        return store.divisionName();
      },
      getUserDelegationName(): string {
        return store.delegationName();
      },
      getUserAreaName(): string {
        return store.areaName();
      },
      setPermission(permission: UserPermission): void {
        patchState(store, { permission });
      },
      getUserPermission(): UserPermission {
        return store.permission();
      },
    };
  })
);
